<div class="component-body">
  <main class="main d-flex align-items-center">
    <div class="container">
<br>
<br>
<br>
<br>
<br>

      <div class="row">

      
        <div class="col-sm-12  col-lg-8  col-md-8 mx-auto">

          <div class="card-group">            
            <div class="card p-10"  style="background-color: white;">

    

     <mat-horizontal-stepper #stepper linear  style="background-color:white;">

  
  <!--<div class="input-group-prepend">
                        <span class="input-group-text"><i class="icon-user"></i></span>
                      </div>-->
      
       <mat-step [stepControl]="SignUpForm" [completed]="isCompleted" >
         

          <div style="text-align: center;">
            <h1> <font color="#005b9d">    <img style="max-width:100%; height:auto;" src="../../../../../assets/images/Premier1.jpg" alt="../../../../../assets/images/premierlogonew.jpg" /> </font></h1>
        </div>



                <div style="text-align: center;">
                    <h1> <font color="#005b9d"> {{'Signup.TranslationSection.text1' | translate}}</font></h1>
                </div>
  
                <div class="card-body" >
                 
                  <form [formGroup] = "SignUpForm" (ngSubmit)="goForward(stepper)" novalidate>
                    <h1>{{'Signup.TranslationSection.text2' | translate}}</h1>
                    <p class="text-muted" style="max-width:100%; height:auto;">{{'Signup.TranslationSection.text3' | translate}}(<b>{{'Signup.TranslationSection.text4' | translate}}</b>)</p>

                    <div  style="max-width:100%; height:auto; font-weight: bold; text-align: left; color: #005b9d;">
                    
                      {{'Signup.TranslationSection.text5' | translate}}<br><br>

                    <ul>
                      <li><b>{{'Signup.TranslationSection.text6' | translate}}</b></li>
                      <li><b>{{'Signup.TranslationSection.text7' | translate}}</b></li>
                      <li><b>{{'Signup.TranslationSection.text8' | translate}}</b></li>
                      <li><b>{{'Signup.TranslationSection.text9' | translate}}</b></li>
                    </ul>
    
                    
                    </div>

                    <div class="form-row" style="height: 50px;">
                    </div>

        
                    <div class="form-row" >
                      <div class="form-group col-lg-7 col-md-7 col-sm-7">

                    <div *ngIf="showErrorMessage">
                      <label style="font-size: small;color:#b30000">{{'Signup.TranslationSection.text10' | translate}}</label>
                    </div>

                    <div *ngIf="showAllFieldsMessage">
                      <label style="font-size: small;color:#b30000">{{'Signup.TranslationSection.text11' | translate}}</label>
                    </div>

                   
                              
                    <div class="form-group col-sm-12 col-md-12 col-lg-12" style="text-align: left;">

                      <label for="name" class="control-label">{{'Signup.TranslationSection.text12' | translate}}</label>
                      <input type="text" class="form-control" formControlName = "firstName" placeholder="" >

                    </div>

                    <div class="form-group col-sm-12 col-md-12 col-lg-12" style="text-align: left;">
                  
                      <label for="name" class="control-label">{{'Signup.TranslationSection.text13' | translate}}</label>
                      <input type="text" class="form-control" formControlName = "lastName" placeholder=""  >

                    </div>


                    <div class="form-group col-sm-12 col-md-12 col-lg-12" style="text-align: left;">
              
                      <label for="name" class="control-label">{{'Signup.TranslationSection.text14' | translate}}</label>
                      <input type="email" class="form-control" formControlName = "username" >

                      

                     <!-- <div *ngIf="showinvalidmessage">
                        <small style="font-size: small;color:#b30000">Enter a valid email address</small>
                      </div>-->

                      <div *ngIf="this.SignUpForm.get('username').hasError('emailTaken')"><span style="color: #b30000;">{{'Signup.TranslationSection.text15' | translate}}</span>
                      </div>

                      <div *ngIf="this.SignUpForm.get('username').hasError('emailNotValid')"><span style="color: #b30000;">{{'Signup.TranslationSection.text16' | translate}}</span>
                      </div>
  

                    </div>


                    <div class="form-group col-sm-12 col-md-12 col-lg-12" style="text-align: left;">
                    
                      <label for="name" class="control-label">{{'Signup.TranslationSection.text17' | translate}}</label>
                      <input type="password" class="form-control" formControlName="password" placeholder=""
                        autocomplete="current-password">
                      

                    </div>
                    <div class="form-group col-sm-12 col-md-12 col-lg-12" style="text-align: left;">
           
                      <label for="name" class="control-label">{{'Signup.TranslationSection.text18' | translate}}</label>
                      <input type="password" class="form-control" formControlName="passwordconfirm"
                        placeholder="" autocomplete="confirm-password" >

                   
                    </div>
                      <div class="row">
                        <mat-error *ngIf="SignUpForm.hasError('notSame')">
                                            
                          <label style="font-size: small;color:#b30000">{{'Signup.TranslationSection.text19' | translate}}</label>
                      
                      </mat-error>
                      </div>

                      <div class="row">
                        <div style="color: #b30000;" *ngIf="f.password.errors?.minlength">{{'Signup.TranslationSection.text20' | translate}}</div>
                        </div>

                

                 
                    <div class="row">
                      <div class="col">  
                      
                        <a class="nav-link" [routerLink]="['/login']" value="Sign In" style="color: blue; font-size: small;" (click)="signin()">{{'Signup.TranslationSection.text21' | translate}}</a>

                      </div>
                      <div class="col">
                          <div >  <button  type="submit"  style="background-color:#005b9d; color:white; width:100px;" class="btn btn-md float-left" matStepperNext>{{'Signup.TranslationSection.text22' | translate}}</button>
                          
                           <!-- <button type="submit" class="btn btn-create" matStepperNext >Next</button> -->
                          
                          </div>
                      </div>
                    </div>


                    <div class="row">
               
         
                 
                      <div id="loadimage">
                          <img *ngIf="loading" style = "width:40px; height:40px;" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                      </div>
                    </div>


                  </div>

                  <div class="col-lg-1 col-md-1 col-sm-1">

                  </div>

                      <div class="form-group col-lg-4 col-md-4 col-sm-4" >
                        <img style="max-width:100%; height:auto;"  src="../../../../../assets/images/elderlymother2.jpg" alt="../../../../../assets/images/careers-feature.jpg"/> 

                      </div>
                    </div>

                  </form>
                </div>



          </mat-step>
  


          <mat-step  [stepControl]="SignUpForm">

          <div class="card-body">
            <app-terms-view [signupForm]="SignUpForm" ></app-terms-view>
          </div>
        
          </mat-step>
        

        </mat-horizontal-stepper>


      </div>    
    </div>


        </div>
      </div>
    </div>
  </main>
</div>


